
// @see https://auth0.com/docs/libraries/error-messages
const auth0ErrorCodes = {
  userExists: 'user_exists',
  unauthorized: 'unauthorized',
  invalidPassword: 'invalid_password',
  PasswordStrengthError: 'PasswordStrengthError'
};

export default auth0ErrorCodes;


// WEBPACK FOOTER //
// ./src/constants/auth0-error-codes.js